import { createSlice } from '@reduxjs/toolkit';

export const columnsSlice = createSlice({
    name: "columns",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        },
        update: (state, action) => {
            const copiedData: any = [...state];
            const index = copiedData.findIndex((x: any) => x.Id === action.payload.Id);
            copiedData[index] = action.payload;
            state = copiedData;
            return state;
        }
    }
})

export const columnsActions = columnsSlice.actions;

export default columnsSlice.reducer;